import React, { useEffect } from "react";
import styles from "../../styles/components/listWithoutCheck.module.scss";

export default function index(props) {
  //console.log(props, "dropdownParent")
  const dropRef = React.useRef(null);

  const optionSelected = (option) => {
    if (option == "No parent Selected") {
      return;
    } else {
      props.getDropdownValue(option, props.dropdownParent, props.haveRelated);
    }
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (props.closeAllDropdowns) {
            props.closeAllDropdowns();
          }
        }
      }

      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(dropRef);

  {
    console.log("props.dropdownParent", props.dropdownParent);
  }

  return (
    <div
      className={
        props.params === "approval"
          ? styles.approvalcontainer
          : props.params === "profile"
          ? styles.profilecontainer
          : props.params === "userAccessEdit"
          ? styles.userAccessEditContainer
          : props.params == "demandModal"
          ? styles.demandModalContainer
          : props.params === "demandFilters"
          ? styles.demandFiltersContainer
          : props.params == "botDetailDocument"
          ? styles.botDetailDocumentContainer
          : props.params == "botStoreFilters"
          ? styles.botStoreFiltersContainer
          : props.params == "userAccess"
          ? styles.userAccessFiltersContainer
          : styles.listContainer
      }
      ref={dropRef}
    >
      <div
        className={
          props.params === "approval"
            ? styles.listapproval
            : props.params === "userAccessEdit"
            ? styles.listUserAccessEdit
            : props.params == "demandModal"
            ? styles.listDemandModal
            : props.params === "demandFilters"
            ? styles.listDemandFilters
            : props.params == "botDetailDocument"
            ? styles.listBotDetailDocument
            : props.params == "botStoreFilters"
            ? styles.listBotStoreFilters
            : props.params == "userAccess"
            ? styles.listUserAccessFilters
            : styles.listUlContainer
        }
      >
        {props.dropdownParent == "status" ||
        props.dropdownParent == "User type" ||
        props.dropdownParent === "eTProfile" ? (
          <ul>
            {props.values.map((option, index) => (
              <li
                style={{
                  backgroundColor:
                    option === "Create new ET Profile" ? "#1f36c7" : "inherit",
                  color:
                    option === "Create new ET Profile" ? "#fff" : "inherit",
                }}
                onClick={() => optionSelected(option)}
              >
                {option}
              </li> // give a color on hover , make curson pointer,
            ))}
          </ul>
        ) : (
          <ul>
            {props.values.sort().map((option, index) => (
              <li onClick={() => optionSelected(option)}>{option}</li> // give a color on hover , make curson pointer,
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

